import { createApp } from 'vue'
import Vant from 'vant'

import App from './App.vue'
import router from './router'
import 'vant/lib/index.css' // 全局引入样式
const app = createApp(App).use(Vant) // 创建实例

const baseurl = process.env.NODE_ENV === 'production' 
  ? 'https://oa.tianhe.net/UploadFiles/'   // 部署模式
  : 'http://localhost:1920/UploadFiles/'   // 开发模式

// 全局过滤器 
app.config.globalProperties.$filters = {
  prefix(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `${url}`
      return url
    }
  }
};
//全局图片的处理
const fixedPic = {
  prefix_face(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `${url}`
      return url
    }
  },
  prefix_car(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `CarImages/${url}`
      return url
    }
  },
  prefix_car_use(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `CarUseImages/${url}`
      return url
    }
  },
  prefix_seal(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `Seal/${url}`
      return url
    }
  },
  prefix_seal_chop(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `SealImages/${url}`
      return url
    }
  },
  prefix_notice_files(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `NoticeFiles/${url}`
      return url
    }
  },
  prefix_paitask_files(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `TaskPaiFiles/${url}`
      return url
    }
  },
  prefix_find_pics(url) {
    if (url && url.startsWith('http')) {
      return url
    } else {
      url = baseurl + `FindPic/${url}`
      return url
    }
  },
};

app.use(router);
app.provide('$fixedPic', fixedPic);

app.mount('#app');